import httpService from "./httpService";

export default {
  create: async ach => httpService.post("/ach", ach),
  update: async ach => httpService.put(`/ach/${ach.id}`, ach),
  getAll: async () => httpService.get("/ach"),
  get: async id => httpService.get(`/ach/${id}`),
};
